module.exports = __webpack_public_path__ + "media/images/twitter-2df5b78426886e2f9559b628e7f25892.svg";